import { render, staticRenderFns } from "./DoubleBarChart.vue?vue&type=template&id=662747b8&scoped=true"
import script from "./DoubleBarChart.vue?vue&type=script&lang=js"
export * from "./DoubleBarChart.vue?vue&type=script&lang=js"
import style0 from "./DoubleBarChart.vue?vue&type=style&index=0&id=662747b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662747b8",
  null
  
)

export default component.exports